import 'slick-carousel';
import { prefersReducedMotion } from '../utils/prefersReducedMotion';

function imageGalleryCarouselInstance(galleryEl) {
  const $galleryEl = $(galleryEl);

  const galleryUniqueId = $galleryEl.attr('id');

  const imageSlider = $('.carousel-gallery-images', $galleryEl);
  const textSlider = $('.carousel-gallery-text', $galleryEl);

  const totalSlides = $('.carousel-gallery-images__item', $galleryEl).length;

  imageSlider.on('init', () => {
    imageSlider.find('.slick-slide').each(function (i) {
      $(this).attr('aria-label', `slide ${i + 1} of ${totalSlides}`);
      $(this).attr('role', 'group');
      $(this).attr('aria-roledescription', 'slide');
    });
  });

  imageSlider.slick({
    lazyLoad: 'ondemand',
    arrows: true,
    infinite: false,
    speed: prefersReducedMotion() ? 0 : 300,
    autoplay: false,
    asNavFor: `#${galleryUniqueId}-texts`,
    prevArrow:
      '<button class="slick-arrow slick-prev" data-carousel="previous"><i class="c-icon icon-arrow-left-strong" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 0.72937L11.0862 2.31562L4.80875 8.60437H18.5V10.8544H4.80875L11.0862 17.1431L9.5 18.7294L0.499998 9.72937L9.5 0.72937Z" fill="currentColor"></path></svg></i><span class="u-visuallyhidden">Previous slide</span></button>',
    nextArrow:
      '<button class="slick-arrow slick-next" data-carousel="next"><i class="c-icon icon-arrow-right-strong" aria-hidden="true"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.5 0.576416L7.91375 2.16267L14.1913 8.45142H0.5V10.7014H14.1913L7.91375 16.9902L9.5 18.5764L18.5 9.57642L9.5 0.576416Z" fill="currentColor"></path></svg></i><span class="u-visuallyhidden">Next slide</span></button>',
  });

  textSlider.slick({
    arrows: false,
    infinite: false,
    autoplay: false,
    fade: true,
    asNavFor: `#${galleryUniqueId}-images`,
  });

  let currentSlide = imageSlider.slick('slickCurrentSlide');

  imageSlider.on('afterChange', () => {
    currentSlide = imageSlider.slick('slickCurrentSlide');

    $('.carousel-gallery__current', $galleryEl)
      .empty()
      .append(currentSlide + 1);
  });

  $('.carousel-gallery__current', $galleryEl).html(currentSlide + 1);
  $('.carousel-gallery__total', $galleryEl).html(totalSlides);
}

function imageGalleryCarousel() {
  const $galleries = $('[data-image-gallery]');

  $galleries.each((i, gallery) => {
    imageGalleryCarouselInstance(gallery);
  });
}

export function init() {
  imageGalleryCarousel();

  $(window).on('module.reinit', (e, modalContentElement) => {
    imageGalleryCarousel(modalContentElement);
  });
}
